import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LanguageIcon from '@mui/icons-material/Language';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL } from '../data/assets';

const Metrics = () => {
  const theme = useTheme();

  const [viewPortEntered, setViewPortEntered] = useState(false);
  const setViewPortVisibility = (isVisible) => {
    if (viewPortEntered) {
      return;
    }
    setViewPortEntered(isVisible);
  };

  const getIcon = (iconName) => {
    const iconProps = { sx: { fontSize: 40, color: theme.palette.primary.main } };

    switch (iconName) {
      case 'LanguageIcon':
        return <LanguageIcon {...iconProps} />;
      case 'OndemandVideoIcon':
        return <OndemandVideoIcon {...iconProps} />;
      case 'LiveTvIcon':
        return <LiveTvIcon {...iconProps} />;
      case 'BusinessCenterIcon':
        return <BusinessCenterIcon {...iconProps} />;
      default:
        return <LanguageIcon {...iconProps} />;
    }
  };

  const metricsData = [
    {
      title: 30,
      label: 'Visitas mensuales del ecosistema TNO',
      subtitle: 'Web y editorial compartidos.',
      suffix: 'K+',
      icon: getIcon('LanguageIcon'),
    },
    {
      title: 12,
      label: 'Episodios On-Demand disponibles',
      subtitle: 'Biblioteca en crecimiento con expertas y casos reales.',
      suffix: '+',
      icon: getIcon('OndemandVideoIcon'),
    },
    {
      title: 1,
      label: 'Emisión en vivo semanal',
      subtitle: 'Martes 11:00 AM (Venezuela) por TNO Network.',
      suffix: '',
      icon: getIcon('LiveTvIcon'),
    },
    {
      title: 2,
      label: 'Conductoras con trayectoria en marketing y negocios',
      subtitle: 'Loyola Rosales y Luzmey Hernández.',
      suffix: '',
      icon: getIcon('BusinessCenterIcon'),
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            textTransform: 'uppercase',
            fontWeight: 'medium',
          }}
          gutterBottom
          color={'primary'}
          align={'center'}
        >
          Números
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          align={'center'}
          gutterBottom
          color={'primary'}
        >
          Los números de Marketing en Movimiento
        </Box>
        <Typography
          variant={'h6'}
          align={'center'}
          color="textSecondary"
          sx={{ mb: 4 }}
        >
          Tu marca llega a profesionales del marketing, emprendedores y tomadores de decisión que invierten en crecimiento.
        </Typography>
      </Box>
      <Box marginBottom={{ xs: 4, sm: 8, md: 8 }}>
        <Grid container spacing={2}>
          {metricsData.map((item, i) => (
            <Grid key={i} item xs={12} sm={6} md={3}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                marginBottom={2}
              >
                {item.icon}
              </Box>
              <Typography variant="h3" align={'center'} gutterBottom>
                <Box fontWeight={600}>
                  <VisibilitySensor
                    onChange={(isVisible) => setViewPortVisibility(isVisible)}
                    delayedCall
                  >
                    <CountUp
                      redraw={false}
                      end={viewPortEntered ? item.title : 0}
                      start={0}
                      suffix={item.suffix}
                    />
                  </VisibilitySensor>
                </Box>
              </Typography>
              <Typography align={'center'} variant="h6" gutterBottom>
                {item.label}
              </Typography>
              <Typography color="text.secondary" align={'center'} component="p">
                {item.subtitle}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box maxWidth={700} margin={'0 auto'} position={'relative'}>
        <Box
          component={LazyLoadImage}
          height={'100%'}
          width={'100%'}
          src={SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL}
          alt="Marketing en Movimiento — TNO Network"
          effect="blur"
          boxShadow={4}
          borderRadius={1.5}
        />
      </Box>
    </Box>
  );
};

export default Metrics;
